export const SportTypes = {
  all: 1,
  soccer: 2,
  nfl: 3,
  basketball: 4,
  tennis: 5,
  baseball: 6,
  live: 7,
};

export const LoginTypes = {
  Clerk: 'CLERK',
  Player: 'PLAYER',
  Guest: 'GUEST',
};

export const ExternalWagerLoginTypes = {
  DepositTicket: 'DEPOSIT_TICKET',
  RealPlayerKiosk: 'REAL_PLAYER_KIOSK',
  ClerkDepositTicket: 'CLERK_DEPOSIT_TICKET',
  MobileScanCode: 'MOBILE_SCAN_CODE',
};

export const helpPageUrls = {
  119: {
    en: `https://help.instabet.com?lang=en`,
    es: `https://ayuda.instabet.com`,
    pt: `https://ajuda.instabet.com?lang=pt-br`,
  },
  118: {
    en: `https://help.instabet.net?lang=en`,
    es: `https://ayuda.instabet.net?lang=es`,
    pt: `https://ajuda.instabet.net`,
  },
  121: {
    en: `https://help.instabet.mx?lang=en`,
    es: `https://ayuda.instabet.mx`,
    pt: `https://ajuda.instabet.mx?lang=pt-br`,
  },
};
